module.exports = __webpack_public_path__ + "static/media/aug2021.aef1ab68.svg";